import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  IsSmallScreen,
  updateMainHeader,
} from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, {
  IOrderColumns,
} from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../Components/Button/WSButton";
import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";
import AddIcon from "@mui/icons-material/Add";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const UserList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  const { add, edit, remove, view } = getPermissions("users"); // role permissions for this page
  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const [productSource, setProductSource] = useState<any>({
    url: "Auth/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [
      {
        field: "UpdatedAt",
        direction: "desc",
      },
    ],
  });
  const source = {
    url: "Auth/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [
      {
        field: "UpdatedAt",
        direction: "desc",
      },
    ],
  };

  useEffect(() => {
    updateMainHeader("User  ");
  });

  breadCrumbsStore.updateBreadCrumbs([{ "User List": "/user/list" }]);

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/user/edit/${row?.id}`);
    }
  };
  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "Auth/search",
      page: 1,
      pageSize: 10,
      filter: [],
      sort: [
        {
          field: "UpdatedAt",
          direction: "desc",
        },
      ],
    };
    switch (value) {
      case "In Stock":
        soureFilter.filter = [
          {
            field: "name",
            operator: "eq",
            value: "In Stock",
          },
        ];
        break;
    }
    //  setProductSource({ ...soureFilter });
  };

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      type: "default",
      sortable: true,
    },
    // {
    //   header: "Email",
    //   fieldName: "email",
    //   tooltip: true,
    //   type: "default",
    // },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
      isHide: isMobile,
      type: "default",
    },
    {
      header: "User Type",
      fieldName: "userType",
      isHide: isMobile,
      isTitleCase: true,
      type: "default",
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      isHide: isMobile,
      type: "date",
    },
    {
      header: "Updated On",
      fieldName: "updatedAt",
      isHide: isMobile,
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default",
      labelSx: { fontWeight: "bold" },
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,

      type: "default",
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      isBoderRadious: true,
      type: "date",
    },
    {
      header: "Updated On",
      fieldName: "updatedAt",
      isBoderRadious: true,
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];
  const handleClick = () => {
    navigate("/user/add");
  };

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.fullName = `${item?.firstName} ${
          item?.lastName ? item?.lastName : ""
        }`;
      });
      return data;
    }
  };
  return (
    <Grid p={3}>
      {/* <Grid container spacing={2}>
        {view ? 
        <Grid item xs={12}>
          {!isMobile && <WSDataGrid
            id="userListGrid"
            title="Users"
            columns={columns}
            source={source}
            transFormData={transFormData}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            searchBox={{ fieldName: 'firstName,company,lastName,mobile' }}
            gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
          />
          }
          {isMobile &&
            <WSMobileDataGridAdvanced title={'Users'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}    transFormData={transFormData} columns={mobColumns} id="userListGrid" source={source} />
          }
        </Grid> : <PermissionDenied />
        }
      </Grid> */}

      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }}
          />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
          <WSButton
            id="btnAddNewProduct"
            label="Add User"
            startIcon={<AddIcon />}
            onClick={handleClick}
            sx={{
              borderRadius: "999px", // pill shape
              backgroundColor: "#098963!important", // green background
              textTransform: "none", // prevent uppercase
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "#087654!important",
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {productSource && (
            <WSDataGridNew
              id="userListGrid"
              title="Users"
              columns={columns}
              source={productSource}
              transFormData={transFormData}
              searchBox={{ fieldName: "name,phoneNumber,userType" }}
              addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
